module.exports = __webpack_public_path__ + "media/images/gift/steps/ceremony-8b054c292a966753e83d2e6cd0ee710c.png";